import React, { useState, useEffect } from 'react';
import { hideWidget, showWidget } from '../../lib/widgetVisibility';

interface CancellationReasonFormProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (category: string, detail: string) => void;
}

const REASON_OPTIONS = [
  { value: 'expensive', label: '料金が高い' },
  { value: 'missing_features', label: '必要な機能が足りない' },
  { value: 'difficult', label: '使い方が難しい' },
  { value: 'unused', label: '利用する機会がなくなった' },
  { value: 'other', label: 'その他' },
];

export const CancellationReasonForm: React.FC<CancellationReasonFormProps> = ({ open, onClose, onConfirm }) => {
  const [category, setCategory] = useState('');

  useEffect(() => {
    if (open) {
      hideWidget();
    } else {
      showWidget();
    }
    return () => { showWidget(); };
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="cancellation-reason-modal"
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
    >
      <div style={{ background: '#fff', borderRadius: '16px', width: '90%', maxWidth: '460px', padding: '32px', boxShadow: '0 20px 50px rgba(15,23,42,0.25)' }}>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#0F172A', marginBottom: '8px' }}>
          プランを解約しますか？
        </div>
        <div style={{ fontSize: '14px', color: '#0a7a72', marginBottom: '20px', lineHeight: 1.65 }}>
          差し支えなければ、解約の理由をお聞かせください。今後のサービス改善に役立てます。
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '22px' }} data-testid="cancellation-reason-radio">
          {REASON_OPTIONS.map((opt) => {
            const isSelected = category === opt.value;
            return (
              <label
                key={opt.value}
                onClick={() => setCategory(opt.value)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  border: isSelected ? '2px solid #0a7a72' : '1px solid #E2E8F0',
                  background: isSelected ? '#F0FDFA' : '#fff',
                  borderRadius: '10px',
                  padding: '13px 14px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  color: isSelected ? '#0F766E' : '#334155',
                  fontWeight: isSelected ? 700 : 400,
                }}
              >
                <span style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: isSelected ? '5px solid #0a7a72' : '2px solid #CBD5E1',
                  flexShrink: 0,
                  display: 'inline-block',
                }} />
                {opt.label}
              </label>
            );
          })}
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            type="button"
            onClick={onClose}
            style={{ flex: 1, background: '#fff', color: '#475569', border: '1px solid #E2E8F0', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}
          >
            解約しない
          </button>
          <button
            type="button"
            data-testid="cancellation-confirm-button"
            onClick={() => onConfirm(category, '')}
            disabled={!category}
            style={{ flex: 1, background: category ? '#DC2626' : '#E5E7EB', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: 700, cursor: category ? 'pointer' : 'not-allowed' }}
          >
            解約する
          </button>
        </div>
      </div>
    </div>
  );
};
